/* Publish by EComposer at 2026-10-31 21:23:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-20fo3m188r1"]=  window.__ectimmers["ecom-20fo3m188r1"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-20fo3m188r1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20fo3m188r1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vtk44mnb54s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vtk44mnb54s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2u68swiudvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2u68swiudvf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dhzz1gho4r5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dhzz1gho4r5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0uhaq2d0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0uhaq2d0e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-su43thb8l59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-su43thb8l59', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8z3b7w8ftfn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8z3b7w8ftfn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sv106qhg3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sv106qhg3j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jkfjag4mdvq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jkfjag4mdvq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tk2p2xgag3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tk2p2xgag3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-clyxn2l7noq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-clyxn2l7noq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2qia7mf047').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2qia7mf047', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tepkyl0z88i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tepkyl0z88i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zkt5b3oc5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zkt5b3oc5g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5vta7ao2zaf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5vta7ao2zaf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yexlxblyftj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yexlxblyftj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yocmvrzyar7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yocmvrzyar7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-thnfluar1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thnfluar1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7qkhmy99k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7qkhmy99k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ta6mhkf0x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ta6mhkf0x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcu9hba64sj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcu9hba64sj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-61t382zc5dm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-61t382zc5dm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jninyp4s0of').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jninyp4s0of', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ntji50e2n3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ntji50e2n3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9ji22f5bd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9ji22f5bd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bj0bkqd7xf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bj0bkqd7xf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55ducimtfpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55ducimtfpn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-et13fu9y7ur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-et13fu9y7ur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yz38a8s8lag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yz38a8s8lag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3y6ybfnco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3y6ybfnco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3b5fxepqa6x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3b5fxepqa6x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2xyng0wrn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2xyng0wrn8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xe5j648w0b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xe5j648w0b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bv0m4ujyfy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bv0m4ujyfy5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nr3p38zgfzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nr3p38zgfzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bgg0216dlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bgg0216dlk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0gnbvel0xf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0gnbvel0xf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zm7ggwoinw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zm7ggwoinw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48nqkohl2e5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48nqkohl2e5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bfqlnup0908').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfqlnup0908', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nfp2z1cqkfs"]=  window.__ectimmers["ecom-nfp2z1cqkfs"] || {};
var s;if(!this.$el)return!1;const t=this.$el,e=this.id;(s=window.__ecomProgressRO)!=null&&s[e]&&(window.__ecomProgressRO[e].disconnect(),delete window.__ecomProgressRO[e]),t.style.opacity=0,setTimeout(function(){t.style.opacity=1},100);function i(){const r=t.querySelector(".el-porgress__line-wrapper"),a=t.querySelector(".el-progress__line-inner");if(!a)return!1;a.classList.remove("el-progress__percent-line-animation");let l=a.querySelector(".el-progress__pie-label");l.innerHTML="",c(a);function c(p){let m={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(d,m).observe(p)}function d(p,m){p.forEach(function(_){if(_.intersectionRatio>0){let b=function(y){let v=0,w=parseFloat(a.dataset.widthLine)||0;if(w==0)return;function S(){y.innerHTML=`${v}%`,v+=1,v>w&&(y.innerHTML=`${w}%`,clearInterval(C))}let C= window.__ectimmers["ecom-nfp2z1cqkfs"]["o9wbf3ajy"] = window.setInterval(S,1e3/parseFloat(a.dataset.widthLine))};a.classList.add("el-progress__percent-line-animation"),a.dataset.widthLine=="100%"&&(r.style.borderTopRightRadius="10px",r.style.borderBottomRightRadius="10px"),b(l),m.unobserve(a)}})}}function n(){const r=t.querySelector(".el-progress__percent-wrapper"),a=t.querySelector(".el-progress__circle");if(!r||!a)return!1;a.classList.remove("element__progress--percent-circle-animated");function l(d,p){d.forEach(m=>{if(m.intersectionRatio>0){let _=function(x){let $=0,E=parseFloat(m.target.dataset.percent)||0;if(E==0)return;function I(){x.innerHTML=`${$}%`,$+=1,$>E&&(x.innerHTML=`${E}%`,clearInterval(j))}let j= window.__ectimmers["ecom-nfp2z1cqkfs"]["fszvna395"] = window.setInterval(I,1e3/parseFloat(m.target.dataset.percent))},b=m.target.querySelector(".el-progress__circle"),y=m.target.querySelector(".el-progress__pie-label"),v=parseFloat(a.getBoundingClientRect().width),w=v*Math.PI,S=w;if(r&&(S=v*Math.PI-v*Math.PI*parseFloat(r.dataset.percent)/100),/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||/iPad|iPhone|iPod/.test(navigator.platform)||navigator.maxTouchPoints&&navigator.maxTouchPoints>2&&/MacIntel/.test(navigator.platform)){a.style.setProperty("stroke-dasharray",w),a.style.setProperty("stroke-dashoffset",w),a.style.setProperty("stroke","var(--stroke)");let x=(w-S)/50,$=0;const E= window.__ectimmers["ecom-nfp2z1cqkfs"]["jms1e9tcq"] = setInterval(function(){$+=x,a.style.setProperty("stroke-dashoffset",w-$),($>w-S||w-S==0)&&(a.style.setProperty("stroke-dashoffset",S),clearInterval(E))},20);_(y)}else b.classList.add("element__progress--percent-circle-animated"),a.style.setProperty("--stroke-dasharray",w),a.style.setProperty("--stroke-dashoffset",S),_(y);p.unobserve(m.target)}})}function c(){let d={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(l,d).observe(r)}c()}if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||/iPad|iPhone|iPod/.test(navigator.platform)||navigator.maxTouchPoints&&navigator.maxTouchPoints>2&&/MacIntel/.test(navigator.platform))setTimeout(n,2e3),setTimeout(i,2e3);else{let r=new ResizeObserver(function(a){a.forEach(function(l){l.contentBoxSize&&(setTimeout(n,150),setTimeout(i,150))})});window.__ecomProgressRO=window.__ecomProgressRO||{},window.__ecomProgressRO[e]=r,r.observe(t)}

                    });
                    
                        document.querySelectorAll('.ecom-nfp2z1cqkfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfp2z1cqkfs', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gttkefqlpi"]=  window.__ectimmers["ecom-gttkefqlpi"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-gttkefqlpi"]["qw1u2g4oi"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-gttkefqlpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gttkefqlpi', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ue13kdcekup"]=  window.__ectimmers["ecom-ue13kdcekup"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-ue13kdcekup"]["aze3wi9cc"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-ue13kdcekup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ue13kdcekup', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nl0tri0zy1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nl0tri0zy1l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9i6datra3y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9i6datra3y', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ums8gjy9f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ums8gjy9f8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-soqmxjh30sm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-soqmxjh30sm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oxmvygg9gk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxmvygg9gk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmraam4guze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmraam4guze', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5r82u7nudm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5r82u7nudm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-84b01a1xzli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-84b01a1xzli', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8l32e41bcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8l32e41bcj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-awcfke0rejk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-awcfke0rejk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cx464aqio59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cx464aqio59', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b85t5c2bey').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b85t5c2bey', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xpbwb6lp99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xpbwb6lp99', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dboksnagx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dboksnagx9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cz16g7h5lh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cz16g7h5lh7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtpvoshzcwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtpvoshzcwr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkkrlw40yoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkkrlw40yoa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}